/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityDocMgmtDetails = require('../../common/services/GetEntityDocMgmtDetails');
var GetEnforcementIdentifiers = require('../services/GetEnforcementIdentifiers');
var GetEnforcement = require('../services/GetEnforcement');

var DepEnforcementDashboardView = require('../views/DepEnforcementDashboardView');

module.exports = function(entityId, enforcementId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetEnforcementIdentifiers(enforcementId), GetEnforcement(enforcementId), GetEntityDocMgmtDetails(entityId))
    .done(function(enforcementIdentifiers, enforcement, docMgmt) {
      NavUtils.navigate('dep/entity/' + entityId + '/enforcement/' + enforcementId + '/dashboard');
      Scaffold.content.show(
        new DepEnforcementDashboardView({
          viewMode: 'int',
          model: new Backbone.Model({
            entityId: entityId,
            enforcementIdentifiers: enforcementIdentifiers,
            enforcementId: enforcementId,
            enforcement: enforcement,
            enforcementCSFolderId: docMgmt.enforcementCSFolderId
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
